<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :loading="loading"
        @change="onChange"
      >

      <!-- This attribute is removed from <a-table>
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"        -->
        <template slot="student_code" slot-scope="student_code">
          <span>{{student_code}}</span>
        </template>
        <template slot="full_name" slot-scope="full_name">
          <span>{{full_name}}</span>
        </template>
<!--        <template slot="class" slot-scope="class">
          <span>{{class}}</span>
        </template>-->
        <template slot="section" slot-scope="section">
          <span>{{section}}</span>
        </template>

        <template slot="enroll_status" slot-scope="enroll_status">
          <span class="font-weight-bold">{{enroll_status}}</span>
        </template>
        <template slot="action" slot-scope="text, record" v-if="record.enroll_status === 'ENROLLED'">
          <div class="text-nowrap" >
            <!-- view -->
            <a-tooltip
              placement="top"
              title="View"
            >
              <a href="javascript:" class="btn btn-sm btn-success mr-2" @click="showViewModal(record)">
                <i class="fe fe-eye" />
              </a>
            </a-tooltip>
            <!-- Edit -->
<!--            <a-tooltip
              placement="top"
              title="Edit Registered Parent"
            >
              <a href="javascript:" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
                <i class="btn-addon-icon fe fe-edit" />
              </a>
            </a-tooltip>-->
            <!-- Delete -->
<!--            <a-tooltip
              placement="top"
              title="Delete"
            >
              <a href="javascript:" class="btn btn-sm btn-danger" @click="onDelete(record)">
                <i class="btn-addon-icon fe fe-trash" />
              </a>
            </a-tooltip>-->
          </div>
        </template>
      </a-table>
    </div>

    <edit-student ref="editStudent" :session="session" @edited="handleTableUpdate"/>
    <enrolled-student-details></enrolled-student-details>
  </div>
</template>

<style>
.ant-table-row-expand-icon {
  display: none !important;
}
</style>

<script>

import moment from 'moment'
import EditStudent from '@/components/student/Forms/Edit/index'
import EnrolledStudentDetails from '@/components/appregistration/studentappenrollment/Forms/single/index'

const columns = [
  {
    title: 'Student Code',
    className: 'text-left text-gray-6',
    dataIndex: 'student_code',
    scopedSlots: { customRender: 'student_code' },
    sorter: (a, b) => a.student_code.localeCompare(b.student_code),
  },
  {
    title: 'Full Name',
    className: 'text-left text-gray-6',
    dataIndex: 'full_name',
    scopedSlots: { customRender: 'full_name' },
    sorter: (a, b) => a.full_name.localeCompare(b.full_name),
  },
  /* {
    title: 'Last Name',
    className: 'text-left text-gray-6',
    dataIndex: 'last_name',
    scopedSlots: { customRender: 'last_name' },
    sorter: (a, b) => a.last_name.localeCompare(b.last_name),
  }, */
  {
    title: 'Class',
    className: 'text-left',
    dataIndex: 'class',
    scopedSlots: { customRender: 'class' },
    sorter: (a, b) => a.class.localeCompare(b.class),
  },
  {
    title: 'Section',
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' },
    sorter: (a, b) => a.section - b.section,
  },
  {
    title: 'Enroll Status',
    dataIndex: 'enroll_status',
    scopedSlots: { customRender: 'enroll_status' },
    sorter: (a, b) => a.enroll_status - b.enroll_status,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]
function onChange(sorter) {
  console.log('params', sorter)
}

export default {
  name: 'EnrolledStudentsTable',
  components: {
    EditStudent,
    // RegisteredParentDetails,
    EnrolledStudentDetails,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    session: Number,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
      expandedRowKeys: [],
    }
  },
  watch: {
    // whenever question changes, this function will run
    loading: function () {
      this.selectedRowKeys = []
    },
  },
  methods: {
    onChange,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('selectChange', selectedRowKeys)
    },
    showViewModal: function(record) {
      this.$eventBus.$emit('openViewEnrolledStudentDetailsModal', record)
    },
    /* handleEditClickFromView(studentId) {
      // this.$refs.editStudent.showModal(studentId)
      this.$eventBus.$emit('openStudentEditModal', studentId)
    },
    showEditModal: function(record) {
      // this.$refs.editStudent.showModal(record.id)
      this.$eventBus.$emit('openStudentEditModal', record.id)
    }, */
    handleTableUpdate: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete ${record.first_name} ${record.last_name}?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
